import { useTranslation } from 'react-i18next';
import { Badge } from '@/Domain/components/Shared/Badge/Badge';

interface IntegrationEnabledBadgeProps {
  enabled: boolean;
}

/**
 * Standardized on/off badge shown in the integration sheet header next to the
 * connection badge: green when the bot is enabled (active), neutral grey when disabled.
 */
export const IntegrationEnabledBadge = ({ enabled }: IntegrationEnabledBadgeProps) => {
  const { t } = useTranslation('integrations');

  return (
    <Badge
      variant={enabled ? 'success' : 'secondary'}
      size="sm"
      className="px-2"
      data-testid="integration-enabled-badge"
      data-enabled={enabled || undefined}
    >
      {enabled ? t('status.enabled') : t('status.disabled')}
    </Badge>
  );
};

export default IntegrationEnabledBadge;
